import type { FindRideTranslations } from "./en";

/** Telugu (te) strings for Find a Ride. Missing keys fall back to English. */
export const findRideTe: FindRideTranslations = {
  pageTitle: "రైడ్ కనుగొనండి — దురి రైడ్‌షేరింగ్",
  pageMetaDescription:
    "సెకన్లలో షేర్డ్ ఇంటర్‌సిటీ మరియు ఇంట్రా-సిటీ రైడ్‌లను కనుగొని బుక్ చేయండి. దురిలో పికప్, డ్రాప్, తేదీ మరియు సీట్లు నమోదు చేయండి.",
  heroTitle: "రైడ్ కనుగొనండి",
  heroSubtitleBefore: "సెకన్లలో ",
  heroSubtitleHighlight: "షేర్డ్ ఇంటర్‌సిటీ లేదా ఇంట్రా-సిటీ రైడ్",
  heroSubtitleAfter: " బుక్ చేయండి.",

  pickupLabel: "పికప్ లొకేషన్",
  pickupPlaceholder: "పికప్ లొకేషన్ నమోదు చేయండి",
  dropLabel: "డ్రాప్ లొకేషన్",
  dropPlaceholder: "డ్రాప్ లొకేషన్ నమోదు చేయండి",
  dateLabel: "తేదీ",
  pickDate: "తేదీని ఎంచుకోండి",
  seatsLabel: "అవసరమైన సీట్లు",
  selectSeats: "సీట్లు ఎంచుకోండి",
  myLocation: "నా లొకేషన్ ఉపయోగించండి",
  today: "ఈరోజు",
  tomorrow: "రేపు",
  findRideCta: "రైడ్ కనుగొనండి",
  searchingCta: "రైడ్‌లు వెతుకుతోంది…",

  locationDenied:
    "లొకేషన్ యాక్సెస్ నిరాకరించబడింది. దయచేసి పికప్‌ను మాన్యువల్‌గా వెతకండి.",
  selectPickupDrop:
    "దయచేసి సూచనల నుండి పికప్ మరియు డ్రాప్ లొకేషన్‌లను ఎంచుకోండి.",
  selectDate: "దయచేసి ప్రయాణ తేదీని ఎంచుకోండి.",
  selectSeatsError: "దయచేసి కనీసం 1 సీటు ఎంచుకోండి.",
  pickupDropDifferent: "పికప్ మరియు డ్రాప్ వేర్వేరు లొకేషన్‌లు అయి ఉండాలి.",
  loginRequired: "రైడ్‌లు వెతకడానికి దయచేసి లాగిన్ అవ్వండి.",
  notifyLoginRequired:
    "సెర్చ్ సేవ్ చేసి తర్వాత నోటిఫై పొందడానికి దయచేసి లాగిన్ అవ్వండి.",
  searchFailed: "ఇప్పుడు రైడ్‌లు వెతకలేకపోయాం. దయచేసి మళ్లీ ప్రయత్నించండి.",

  searchingTitle: "రైడ్‌లు కనుగొంటోంది…",
  searchingSubtitle: "మీ మార్గం మరియు తేదీకి హోస్ట్‌లను సరిపోలుస్తోంది.",

  noRidesTitle: "రైడ్‌లు దొరకలేదు",
  noRidesOops: "అయ్యో...",
  noRidesBody:
    "ఈ మార్గానికి ఇంకా రైడ్‌లు అందుబాటులో లేవు. మీ సెర్చ్ సేవ్ చేసి విశ్రాంతి తీసుకోండి — సరిపోలే రైడ్ వచ్చిన వెంటనే మేము మీకు తెలియజేస్తాము",
  refresh: "రిఫ్రెష్",
  saveNotifyCta: "సేవ్ చేసి తర్వాత తెలియజేయండి",
  saveNotifySaving: "సేవ్ అవుతోంది…",
  saveNotifyTitle: "అంతా సిద్ధం",
  saveNotifySuccess:
    "ఈ మార్గానికి సరిపోలే రైడ్ అందుబాటులోకి వచ్చినప్పుడు మేము మీకు తెలియజేస్తాము. మీరు దీన్ని మూసివేసి విశ్రాంతి తీసుకోవచ్చు — హోస్ట్ మ్యాచ్ పోస్ట్ చేసిన వెంటనే మేము సంప్రదిస్తాము.",
  saveNotifyDone: "సరే",
  saveNotifyFailed:
    "నోటిఫై అభ్యర్థనను సేవ్ చేయలేకపోయాం. దయచేసి మళ్లీ ప్రయత్నించండి.",
  featureSafeRides: "సురక్షిత రైడ్‌లు",
  featureVerifiedUsers: "వెరిఫైడ్ యూజర్లు",
  featureBestMatches: "ఉత్తమ మ్యాచ్‌లు",

  trustSafeTitle: "నమ్మకం & సురక్షితం",
  trustSafeBody: "సురక్షిత అనుభవం కోసం వెరిఫైడ్ యూజర్లు",
  trustQuickTitle: "త్వరిత బుకింగ్",
  trustQuickBody: "కొన్ని ట్యాప్‌లలోనే ఇంటర్‌సిటీ లేదా ఇంట్రా-సిటీ రైడ్ బుక్ చేయండి",
  trustSaveTitle: "కలిసి ఆదా చేయండి",
  trustSaveBody: "రైడ్‌లు పంచుకోండి, డబ్బు ఆదా చేయండి, కలిసి ప్రయాణించండి",

  ridesAvailableTitle: "{count} రైడ్‌లు అందుబాటులో ఉన్నాయి",
  ridesAvailableBody:
    "శుభవార్త! మీ మార్గానికి సరిపోలే రైడ్‌లు అందుబాటులో ఉన్నాయి. వివరాలు చూసి సీటు బుక్ చేయండి.",
  viewAndBookCta: "చూసి రైడ్ బుక్ చేయండి",
  editDetails: "వివరాలు మార్చండి",
  editSearch: "సెర్చ్ మార్చండి",
  editLocations: "లొకేషన్‌లు మార్చండి",
  perSeat: "సీటుకు",
  seatsLeft: "{count} సీట్లు అందుబాటులో ఉన్నాయి",
  noRideCards:
    "ఈ సెర్చ్‌కు రైడ్ ID ఉన్న బుక్ చేయదగిన రైడ్‌లు రాలేదు.",
  rideIdLabel: "రైడ్ {id}",
};
